import React from "react"
import About from "../base-pages/about"

const AboutEN = () => {
  return <About lang="en" />
}

export default AboutEN
